// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] + "." + {"126":"a2dec566","285":"ff358edb","631":"81c39536"}[chunkId] + ".chunk.css";
};